(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-script"] && !Shopify.designMode) return;
  try {
    (function () {
    const buyButtonsContainer = document.querySelector('.product-details__buy-buttons');
    const footerUtility = document.querySelector('footer.page-footer .footer-utility');

    let stickyObserver = null;
    let resizeObserver = null;
    let stickyButton = null;

    const mobileMediaQuery = window.matchMedia('(max-width: 767px)');

    const syncStickyToVisualViewport = () => {
      if (!stickyButton || !stickyButton.classList.contains('is-sticky')) {
        stickyButton?.style.removeProperty('--sticky-atc-bottom');
        return;
      }

      const vv = window.visualViewport;
      if (!vv) {
        stickyButton.style.setProperty('--sticky-atc-bottom', '0px');
        return;
      }

      const offset = window.innerHeight - vv.height - vv.offsetTop;
      stickyButton.style.setProperty('--sticky-atc-bottom', `${offset}px`);
    };

    const setupObservers = () => {
      if (stickyObserver) stickyObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();

      const currentActionsContainer = buyButtonsContainer?.querySelector('.product-form__actions');
      const currentButton = currentActionsContainer?.querySelector('.product-form__add-to-cart');
      stickyButton = currentButton || null;

      if (!currentActionsContainer || !currentButton) return;

      if (!mobileMediaQuery.matches) {
        currentButton.classList.remove('is-sticky');
        currentButton.style.removeProperty('--sticky-atc-bottom');
        if (footerUtility) footerUtility.style.marginBottom = '';
        return;
      }

      let wrapper = currentActionsContainer.querySelector('.atc-sticky-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'atc-sticky-wrapper';
        // Insert wrapper before the button, then move the button inside the wrapper
        currentButton.parentNode.insertBefore(wrapper, currentButton);
        wrapper.appendChild(currentButton);
      }

      // Lock the wrapper's height permanently
      wrapper.style.height = `${currentButton.offsetHeight}px`;
      wrapper.style.width = '100%';
      wrapper.style.display = 'block';

      // Observe the static wrapper, NOT the button
      stickyObserver = new IntersectionObserver(
        ([entry]) => {
          const isScrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;

          if (isScrolledPast) {
            currentButton.classList.add('is-sticky');
          } else {
            currentButton.classList.remove('is-sticky');
          }
          syncStickyToVisualViewport();
        },
        { threshold: 0 }
      );

      stickyObserver.observe(wrapper);

      if (footerUtility) {
        resizeObserver = new ResizeObserver((entries) => {
          for (let entry of entries) {
            if (currentButton.classList.contains('is-sticky')) {
              const newHeight = entry.borderBoxSize ? entry.borderBoxSize[0].blockSize : entry.target.clientHeight;
              footerUtility.style.marginBottom = `${newHeight}px`;
            } else {
              footerUtility.style.marginBottom = '';
            }
          }
        });
        resizeObserver.observe(currentButton);
      }
    };

    if (buyButtonsContainer) {
      // Add a slight delay to allow dynamic Shopify elements to render their heights properly
      setTimeout(setupObservers, 200);

      mobileMediaQuery.addEventListener('change', setupObservers);
      window.visualViewport?.addEventListener('resize', syncStickyToVisualViewport);
      window.visualViewport?.addEventListener('scroll', syncStickyToVisualViewport);
      window.addEventListener('orientationchange', syncStickyToVisualViewport);

      const domChangeObserver = new MutationObserver((mutations) => {
        let shouldReinit = false;
        for (let mutation of mutations) {
          if (mutation.type === 'childList') {
            // Ignore mutations caused by our own wrapper insertion
            const addedNodes = Array.from(mutation.addedNodes);
            const isOnlyWrapper = addedNodes.every(
              (node) => node.classList && node.classList.contains('atc-sticky-wrapper')
            );

            if (!isOnlyWrapper) {
              shouldReinit = true;
              break;
            }
          }
        }
        if (shouldReinit) {
          setTimeout(setupObservers, 150);
        }
      });

      domChangeObserver.observe(buyButtonsContainer, {
        childList: true,
        subtree: true,
      });
    }
  })();

  // Open cart drawer script to open the cart drawer when the cart_open parameter is present in the URL
  // and remove the parameter from the URL after opening the drawer
  (function () {
    const params = new URLSearchParams(window.location.search);
    if (params.get('cart_open') !== 'true') return;

    function stripCartOpenParam() {
      const p = new URLSearchParams(window.location.search);
      p.delete('cart_open');
      const qs = p.toString();
      window.history.replaceState({}, document.title, window.location.pathname + (qs ? '?' + qs : ''));
    }

    function tryOpenCartDrawer(attempt) {
      const maxAttempts = 50;
      const btn = document.querySelector('[data-drawer-open="[data-mini-cart]"]');
      if (btn) {
        btn.click();
        stripCartOpenParam();
        return;
      }
      if (attempt < maxAttempts) {
        setTimeout(function () {
          tryOpenCartDrawer(attempt + 1);
        }, 200);
      }
    }

    function start() {
      customElements.whenDefined('wyatt-drawer').then(function () {
        requestAnimationFrame(function () {
          tryOpenCartDrawer(0);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.Shopify) return;
    const shopId = window.shopId;
    const merchantName = window.merchantName;
    const shopUrl = window.shopUrl;
    const accessToken = '1f4f13fe320f9b7d9b9a05f89e13ea87';
    const buyerCountry = window.Shopify.country;
    const buyerLocale = window.Shopify.locale;
    const buyerCurrency = window.Shopify.currency ? window.Shopify.currency.active : null;
    const encodedOrigin = encodeURIComponent(shopUrl);
    const iframeSrc = `${shopUrl}/services/login_with_shop/authorize?target_origin=${encodedOrigin}&flow=shop_pay_button`;
    window.shopPaymentConfig = {
      shopId: shopId,
      merchantName: merchantName,
      accessToken: accessToken,
      buyerCountry: buyerCountry,
      buyerLocale: buyerLocale,
      buyerCurrency: buyerCurrency,
      iframeSrc: iframeSrc,
      recommendedConfig: {
        name: 'shop_pay',
        wallet_params: {
          shopId: shopId,
          merchantName: merchantName,
          personalized: true,
        },
      },
      fallbackConfig: {
        name: 'buy_it_now',
        wallet_params: {},
      },
      shopPayWalletParams: {
        shopId: shopId,
        merchantName: merchantName,
        personalized: true,
      },
    };
  });
  } catch(e) { console.error(e); }
})();

})();
